(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fitwood-auto-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fitwood-review-highlights')) {
  customElements.define('fitwood-review-highlights', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.ready = false;
      this.frame = 0;
      this.track = this.querySelector('[data-review-track]');
      const signal = this.abort.signal;
      this.querySelector('[data-review-link]').addEventListener('click', event => {
        const source = this.source();
        if (!source) return;
        event.preventDefault();
        source.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'start'});
      }, {signal});
      let drag = null;
      let blockClick = false;
      this.track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || !matchMedia('(max-width:749px)').matches) return;
        drag = {x:event.clientX,left:this.track.scrollLeft,id:event.pointerId,moved:false};
      }, {signal});
      this.track.addEventListener('pointermove', event => {
        if (!drag || event.pointerId !== drag.id) return;
        const dx = event.clientX-drag.x;
        if (!drag.moved && Math.abs(dx)<6) return;
        drag.moved = true;
        this.track.setPointerCapture(event.pointerId);
        this.track.classList.add('is-dragging');
        event.preventDefault();
        this.track.scrollLeft = drag.left-dx;
      }, {signal});
      const endDrag = () => {blockClick=!!drag?.moved;drag=null;this.track.classList.remove('is-dragging');setTimeout(()=>{blockClick=false;},250);};
      this.track.addEventListener('pointerup',endDrag,{signal});
      this.track.addEventListener('pointercancel',endDrag,{signal});
      this.track.addEventListener('dragstart',event=>event.preventDefault(),{signal});
      this.track.addEventListener('click',event=>{if(blockClick){event.preventDefault();event.stopPropagation();}},{capture:true,signal});
      const start = () => this.observeSource();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true,signal});
      else start();
      document.addEventListener('shopify:section:load',start,{signal});
    }
    source() {
      const suffix = '__'+this.dataset.sourceSection;
      return Array.from(document.querySelectorAll('[id^="shopify-section-"]')).find(el=>el.id.endsWith(suffix));
    }
    observeSource() {
      if (this.ready) return;
      const source = this.source();
      if (!source) return;
      this.observer?.disconnect();
      this.observer = new MutationObserver(()=>{
        if (!this.frame) this.frame=requestAnimationFrame(()=>{this.frame=0;this.readReviews();});
      });
      this.observer.observe(source,{childList:true,subtree:true,characterData:true});
      this.readReviews();
    }
    readReviews() {
      const source = this.source();
      if (!source) return;
      const widget = source.querySelector('#fulfilled-reviews-all,#klaviyo-reviews-all,#klaviyo-reviews-list,#fulfilled-reviews-list,#klaviyo-product-reviews-wrapper');
      if (!widget) return;
      const sourceProduct = widget.getAttribute('data-id');
      if (sourceProduct && sourceProduct !== this.dataset.productId) return;
      const reviews = Array.from(widget.querySelectorAll('.kl_reviews__review_item')).map(item=>{
        const content=item.querySelector('.kl_reviews__review__content')?.textContent.trim();
        const ratingEl=item.querySelector('.kl_reviews__review_stars_and_time [role="img"][aria-label]');
        const match=ratingEl?.getAttribute('aria-label')?.match(/[1-5](?:[.,]\d+)?/);
        const rating=match?Number(match[0].replace(',','.')):0;
        if (!content || !rating || rating>5) return null;
        const author=item.querySelector('.kl_reviews__review__author');
        const authorName=author?.firstElementChild?.tagName==='DIV'?author.firstElementChild.textContent.trim():'';
        return {content,rating,title:item.querySelector('.kl_reviews__review__title')?.textContent.trim(),author:authorName,verified:item.querySelector('.kl_reviews__review__verified')?.textContent.trim(),incentive:item.querySelector('.kl_reviews__review__incentive')?.textContent.trim()};
      }).filter(Boolean).slice(0,3);
      if (!reviews.length) return;
      const templates=this.querySelectorAll('[data-review-card]');
      const fragment=document.createDocumentFragment();
      reviews.forEach((review,index)=>{
        const card=templates[index].content.cloneNode(true);
        const stars=card.querySelector('[data-review-stars]');
        stars.textContent='★'.repeat(Math.round(review.rating))+'☆'.repeat(5-Math.round(review.rating));
        stars.setAttribute('role','img');
        stars.setAttribute('aria-label',review.rating+'/5');
        for (const key of ['content','title','author','verified','incentive']) {
          const el=card.querySelector('[data-review-'+key+']');
          if (review[key]) {el.textContent=review[key];el.hidden=false;}
        }
        fragment.append(card);
      });
      this.track.replaceChildren(fragment);
      this.track.style.setProperty('--review-count',String(reviews.length));
      const average=widget.querySelector('.kl_reviews__summary__average_value')?.textContent.trim();
      const count=widget.querySelector('.kl_reviews__summary__stars__count')?.textContent.trim();
      if (average) {
        const overall=this.querySelector('[data-review-overall]');
        overall.textContent=average+'/5'+(count?' · '+count:'');
        overall.hidden=false;
      }
      this.hidden=false;
      if (reviews.length===3) {this.ready=true;this.observer?.disconnect();}
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort=null;
      this.observer?.disconnect();
      if(this.frame)cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fitwood-product-age-teaser"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fitwood-product-age-teaser')) {
  customElements.define('fitwood-product-age-teaser', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.choices = Array.from(this.querySelectorAll('[data-product-age-choice]'));
      this.panels = Array.from(this.querySelectorAll('[data-product-age-panel]'));
      if (!this.choices.length || !this.panels.length) return;
      const signal = this.controller.signal;
      this.addEventListener('click', event => {
        const choice = event.target.closest('[data-product-age-choice]');
        const next = event.target.closest('[data-product-age-next]');
        if ((!choice && !next) || !this.contains(choice || next)) return;
        event.preventDefault();
        this.selectStage(choice ? choice.dataset.productAgeChoice : next.dataset.productAgeNext, !!next);
      }, { signal });
      this.addEventListener('keydown', event => {
        const choice = event.target.closest('[data-product-age-choice]');
        if (!choice || !this.contains(choice)) return;
        const current = this.choices.indexOf(choice);
        let index;
        if (event.key === 'ArrowRight') index = (current + 1) % this.choices.length;
        if (event.key === 'ArrowLeft') index = (current - 1 + this.choices.length) % this.choices.length;
        if (event.key === 'Home') index = 0;
        if (event.key === 'End') index = this.choices.length - 1;
        if (index === undefined) return;
        event.preventDefault();
        this.selectStage(this.choices[index].dataset.productAgeChoice, true);
      }, { signal });
      this.addEventListener('shopify:block:select', event => {
        const choice = event.target.closest('[data-product-age-choice]');
        if (choice) this.selectStage(choice.dataset.productAgeChoice, false);
      }, { signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
    selectStage(id, focus) {
      const selected = this.choices.find(choice => choice.dataset.productAgeChoice === id);
      if (!selected) return;
      this.choices.forEach(choice => {
        const active = choice === selected;
        choice.setAttribute('aria-selected', String(active));
        choice.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach(panel => { panel.hidden = panel.dataset.productAgePanel !== id; });
      if (focus) {
        selected.focus({ preventScroll: true });
        const nav = selected.parentElement;
        const left = selected.getBoundingClientRect().left - nav.getBoundingClientRect().left + nav.scrollLeft - (nav.clientWidth - selected.clientWidth) / 2;
        nav.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-collection-slider"] && !Shopify.designMode) return;
  try {
    
function initializeCollectionSwipe() {
  document.querySelectorAll('.section-carousel .flickity-disabled-mobile').forEach(track => {
    if (track.dataset.mouseSwipeReady) return;
    track.dataset.mouseSwipeReady = 'true';
    let drag = null;
    let blockClick = false;
    track.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0 || !matchMedia('(max-width:749px)').matches) return;
      drag = {x:event.clientX, scroll:track.scrollLeft, id:event.pointerId, moved:false};
      blockClick = false;
    });
    track.addEventListener('pointermove', event => {
      if (!drag || event.pointerId !== drag.id) return;
      const distance = event.clientX - drag.x;
      if (!drag.moved && Math.abs(distance) < 6) return;
      if (!drag.moved) {
        drag.moved = true;
        track.setPointerCapture(event.pointerId);
        track.classList.add('is-mouse-dragging');
      }
      event.preventDefault();
      track.scrollLeft = drag.scroll - distance;
    });
    const finish = () => {
      if (!drag) return;
      blockClick = drag.moved;
      track.classList.remove('is-mouse-dragging');
      drag = null;
      setTimeout(() => { blockClick = false; }, 200);
    };
    track.addEventListener('pointerup', finish);
    track.addEventListener('pointercancel', finish);
    track.addEventListener('pointerleave', () => { if (drag && !drag.moved) drag = null; });
    track.addEventListener('dragstart', event => event.preventDefault());
    track.addEventListener('click', event => {
      if (blockClick) { event.preventDefault(); event.stopPropagation(); blockClick = false; }
    }, true);
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeCollectionSwipe, {once:true});
else initializeCollectionSwipe();
document.addEventListener('shopify:section:load', initializeCollectionSwipe);

function initializeCollectionHeight() {
  document.querySelectorAll('[data-fw-native-collection-swipe]').forEach(track => {
    if (track.dataset.fwHeightReady) return;
    track.dataset.fwHeightReady = 'true';
    let frame = 0;
    const cells = new Set();
    const update = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        const viewport = track.querySelector(':scope > .flickity-viewport');
        if (!viewport) return;
        const heights = Array.from(viewport.querySelectorAll(':scope > .flickity-slider > [data-carousel-slide]'), cell => cell.getBoundingClientRect().height);
        const height = Math.ceil(Math.max(0, ...heights));
        if (height > 0 && Math.abs(viewport.getBoundingClientRect().height - height) > 0.5) viewport.style.height = height + 'px';
      });
    };
    const resize = new ResizeObserver(update);
    resize.observe(track);
    const observeCards = () => {
      track.querySelectorAll('[data-carousel-slide]').forEach(cell => {
        if (cells.has(cell)) return;
        cells.add(cell);
        resize.observe(cell);
      });
      update();
    };
    const mutations = new MutationObserver(observeCards);
    mutations.observe(track, {childList: true, subtree: true});
    observeCards();
    const cleanup = event => {
      if (!event.target.contains(track)) return;
      resize.disconnect();
      mutations.disconnect();
      cancelAnimationFrame(frame);
      document.removeEventListener('shopify:section:unload', cleanup);
    };
    document.addEventListener('shopify:section:unload', cleanup);
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeCollectionHeight, {once: true});
else initializeCollectionHeight();
document.addEventListener('shopify:section:load', initializeCollectionHeight);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wall-bars-products"] && !Shopify.designMode) return;
  try {
    
function initializeWallBarSwipe() {
  document.querySelectorAll('.fw-products__track').forEach(track => {
    if (track.dataset.swipeReady) return;
    track.dataset.swipeReady = 'true';
    let drag = null;
    let blockClick = false;
    track.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0 || !matchMedia('(max-width:749px)').matches) return;
      drag = {x:event.clientX, scroll:track.scrollLeft, id:event.pointerId, moved:false};
      blockClick = false;
    });
    track.addEventListener('pointermove', event => {
      if (!drag || event.pointerId !== drag.id) return;
      const distance = event.clientX - drag.x;
      if (!drag.moved && Math.abs(distance) < 6) return;
      if (!drag.moved) {
        drag.moved = true;
        track.setPointerCapture(event.pointerId);
        track.classList.add('is-dragging');
      }
      event.preventDefault();
      track.scrollLeft = drag.scroll - distance;
    });
    const finish = () => {
      if (!drag) return;
      blockClick = drag.moved;
      track.classList.remove('is-dragging');
      drag = null;
      setTimeout(() => { blockClick = false; }, 200);
    };
    track.addEventListener('pointerup', finish);
    track.addEventListener('pointercancel', finish);
    track.addEventListener('pointerleave', () => { if (drag && !drag.moved) drag = null; });
    track.addEventListener('dragstart', event => event.preventDefault());
    track.addEventListener('click', event => {
      if (blockClick) { event.preventDefault(); event.stopPropagation(); blockClick = false; }
    }, true);
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeWallBarSwipe, {once:true});
else initializeWallBarSwipe();
document.addEventListener('shopify:section:load', initializeWallBarSwipe);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wall-bars-reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const link = event.target.closest('[data-fw-reviews-scroll]');
  if (!link) return;
  const target = document.getElementById(link.hash.slice(1));
  if (!target) return;
  event.preventDefault();
  target.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start'});
});

function initializeFamilyReviewSwipe() {
  document.querySelectorAll('.fw-reviews__track').forEach(track => {
    if (track.dataset.swipeReady) return;
    track.dataset.swipeReady = 'true';
    let drag = null;
    let blockClick = false;
    track.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0 || !matchMedia('(max-width:749px)').matches) return;
      drag = {x:event.clientX, scroll:track.scrollLeft, id:event.pointerId, moved:false};
      blockClick = false;
    });
    track.addEventListener('pointermove', event => {
      if (!drag || event.pointerId !== drag.id) return;
      const distance = event.clientX - drag.x;
      if (!drag.moved && Math.abs(distance) < 6) return;
      if (!drag.moved) {
        drag.moved = true;
        track.setPointerCapture(event.pointerId);
        track.classList.add('is-dragging');
      }
      event.preventDefault();
      track.scrollLeft = drag.scroll - distance;
    });
    const finish = () => {
      if (!drag) return;
      blockClick = drag.moved;
      track.classList.remove('is-dragging');
      drag = null;
      setTimeout(() => { blockClick = false; }, 200);
    };
    track.addEventListener('pointerup', finish);
    track.addEventListener('pointercancel', finish);
    track.addEventListener('pointerleave', () => { if (drag && !drag.moved) drag = null; });
    track.addEventListener('dragstart', event => event.preventDefault());
    track.addEventListener('click', event => {
      if (blockClick) { event.preventDefault(); event.stopPropagation(); blockClick = false; }
    }, true);
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeFamilyReviewSwipe, {once:true});
else initializeFamilyReviewSwipe();
document.addEventListener('shopify:section:load', initializeFamilyReviewSwipe);

  } catch(e) { console.error(e); }
})();
})();
